// extracted by mini-css-extract-plugin
export default {"previewData":"OfferAccordion_previewData__bARZb","previewData__cell":"OfferAccordion_previewData__cell__3B4rI","previewData__title":"OfferAccordion_previewData__title__IjZiu"};